import React, {useEffect, useState} from "react";
import {Alert} from 'reactstrap';
import useGlobal from "../utils/globalStore";
import {SubmitCovidResponse} from "../api/covid-submit-service";
import {GLOBALS} from "../config/env";


function CovidFinal(props) {
    // eslint-disable-next-line
    const [globalState, globalActions] = useGlobal();
    const [response, updateResponse] = useState(initState(globalState.answers))

    useEffect( () => {
        const answers = globalState.answers;

        SubmitCovidResponse(answers,updateResponse)().finally( () => {
            globalActions.resetState();
        })
    }, [])

    const displaySubmission = () => {
        if(GLOBALS.env !== "prod"){
            const alert = response.status === "Success" ? "info": "danger";
            return <Alert color={alert}>{response.status}</Alert>
        }
    }

    //console.log("globalState :" + JSON.stringify(globalState));
    return (
        <div>
            <Alert color="primary">Thanks!</Alert>
            <Alert color={response.alert}>{response.message}</Alert>
            {displaySubmission()}
            <p><a title={response.status}>...</a></p>
        </div>
    );
}

const initState = (answers) => {
    const response = {message: "", alert: "", status: ""};
    const {symptomsYesNo,contactYesNo } = answers;
    if (symptomsYesNo === "symptomsNo" && contactYesNo === "contactNo") {
        response.message = "Because you answered no to both questions, please report to work as scheduled. "
        response.alert = "info";
    }
    else{
        response.message = "Because you answered yes to one of the questions, please talk to your Store Leader or Assistant Store Leader to alert them you will not be able to work today so they can plan for coverage. Please leave the store immediately and reach out to HR for next steps.";
        response.alert = "danger";
    }
    return  response;
}

export default CovidFinal;